module.exports = __webpack_public_path__ + "static/img/21map2.d41c89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/04sportDesc/21map2.png
// module id = E3C3
// module chunks = 0